import { render } from "./karumabanner.vue?vue&type=template&id=7783865f&scoped=true"
import script from "./karumabanner.vue?vue&type=script&lang=js"
export * from "./karumabanner.vue?vue&type=script&lang=js"

import "./karumabanner.vue?vue&type=style&index=0&id=7783865f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7783865f"]])

export default __exports__